import { FC } from "react";
import Chip from "@mui/material/Chip";

// Thresholds & colours per SIMS-5793 spec:
//   >= 80 % → teal
//   50–79 % → amber
//   < 50 %  → coral
const TEAL = "#1D9E75";
const AMBER = "#F2A93B";
const CORAL = "#D85A30";

interface EngagementRateBadgeProps {
	rate: number;
}

const EngagementRateBadge: FC<EngagementRateBadgeProps> = ({ rate }) => {
	const safe = Number.isFinite(rate) ? rate : 0;
	const bg = safe >= 80 ? TEAL : safe >= 50 ? AMBER : CORAL;
	return (
		<Chip
			label={`${Math.round(safe)}%`}
			size="small"
			sx={{
				bgcolor: bg,
				color: "#fff",
				fontWeight: 600,
				minWidth: 64,
			}}
		/>
	);
};

export default EngagementRateBadge;
